import { render, staticRenderFns } from "./AdvicesHub.vue?vue&type=template&id=00a9d14d&"
import script from "./AdvicesHub.vue?vue&type=script&lang=js&"
export * from "./AdvicesHub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports